import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c298ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memo-editor" }
const _hoisted_2 = {
  key: 0,
  class: "memo-error"
}
const _hoisted_3 = {
  key: 1,
  class: "memo-hint"
}
const _hoisted_4 = {
  key: 2,
  class: "memo-hint"
}
const _hoisted_5 = { class: "memo-actions" }
const _hoisted_6 = ["title", "aria-label"]
const _hoisted_7 = {
  key: 0,
  class: "memo-error"
}
const _hoisted_8 = {
  key: 1,
  class: "memo-pencil"
}
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createBlock(_component_a_popover, {
    visible: _ctx.visible,
    trigger: "click",
    title: "客户备注（与客户管理同步）",
    onVisibleChange: _ctx.changeVisible
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_textarea, {
          value: _ctx.draft,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
          maxlength: 2000,
          rows: 4,
          disabled: _ctx.opening || _ctx.saving || !!_ctx.state?.error || !_ctx.state?.canEdit,
          placeholder: "填写客户备注，清空后保存可删除备注"
        }, null, 8, ["value", "disabled"]),
        (_ctx.state?.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.state.error) + " ", 1),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
              }, "重试")
            ]))
          : (_ctx.state?.ready && !_ctx.state?.canEdit)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "客户未绑定电话号码，暂时仅可查看备注。"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "与客户电话号码关联，客户管理和该客户各订单共用一份备注。")),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible=false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            size: "small",
            type: "primary",
            loading: _ctx.saving || _ctx.opening,
            disabled: _ctx.opening || _ctx.saving || !!_ctx.state?.error || !_ctx.state?.canEdit,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.customerId)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "customer-memo-cell",
            title: _ctx.state?.error || _ctx.state?.memo || '点击编辑客户备注',
            "aria-label": _ctx.state?.memo?'编辑客户备注':'添加客户备注',
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.state?.ready ? _ctx.state.memo : ''), 1),
            (_ctx.state?.error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "读取失败，点击重试"))
              : (!_ctx.state?.memo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✎"))
                : _createCommentVNode("", true)
          ], 8, _hoisted_6))
        : (_openBlock(), _createElementBlock("span", _hoisted_9))
    ]),
    _: 1
  }, 8, ["visible", "onVisibleChange"]))
}